import { BrowserRouter, Route, Routes } from "react-router-dom";

import SignIn from "../views/SignIn";
import Auth from "../layouts/Auth/Auth";
import ForgetPassword from "../views/ForgetPassword";

export const AuthRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Auth />}>
          <Route path="/" element={<SignIn />} />
          <Route path="/recover" element={<ForgetPassword />} />
          <Route path="*" element={<SignIn />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
